/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { Grid } from '@mui/system';
import { useState } from 'react';
import { useProjectsListQuery } from '../../../project/api';
import { useDebounce } from '../../../react-components/useDebounce';
import { useLocalStorage } from '../../../react-components/useLocalStorage';
import ProjectsList from './ProjectsList';
import ProjectsMap from './ProjectsMap';

function ProjectListing() {
  const [hoveredProjectId, setHoveredProjectId] = useState<string | null>(null);
  const searchState = useState('');
  const starredState = useLocalStorage('starred-projects-filter', false);
  const limitState = useState(10);
  const debouncedSearch = useDebounce(searchState[0]);

  const projectListQuery = useProjectsListQuery({
    apiOptions: {
      sortBy: 'lastModifiedAt',
      name: debouncedSearch,
      starred: starredState[0],
      limit: limitState[0],
    },
  });

  return (
    <>
      <Grid size={{ lg: 4, md: 5, xs: 12 }}>
        <ProjectsList
          projectListQuery={projectListQuery}
          setHoveredProjectId={setHoveredProjectId}
          searchState={searchState}
          starredState={starredState}
          limitState={limitState}
        />
      </Grid>
      <Grid size={{ lg: 8, md: 7, xs: 12 }}>
        <ProjectsMap
          hoveredProjectId={hoveredProjectId}
          queryOptions={{ apiOptions: { name: debouncedSearch, starred: starredState[0] } }}
        />
      </Grid>
    </>
  );
}

export default ProjectListing;
